import React from 'react';
import GroupPermissionContainer from '@src/containers/GroupPermission';

const GroupPermission = () => <GroupPermissionContainer />;

export default GroupPermission;
